import { trigger, state, style, transition, animate } from '@angular/animations';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MENU_USER_DATA_CONSTANT } from '@constants/permissions/menu/menu-user-data.constants';
import { MenuUserConfigModel } from '@core/models/outros/menu-user-config.model';

import { MenuService } from '@core/services/outros/menu.service';
import { UserLoginModel } from '@models/outros/user-login.model';
import { UserControllerService } from '@services/outros/user-controller.service';
@Component({
  selector: 'app-menu-button',
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.scss'],
  animations: [
    trigger('showMenu', [
      state(
        'expanded',
        style({ height: '100vh', minHeight: '100vh' })
      ),
      state(
        'collapsed',
        style({ height: '0', minHeight: '0' })
      ),
      transition(
        'expanded => collapsed',
        [animate('0.2s')]
      ),
      transition(
        'collapsed => expanded',
        [animate('0.2s')]
      )
    ])
  ]
})
export class MenuButtonComponent implements OnInit, AfterViewInit {

  user: UserLoginModel;
  @Input() show: boolean = false;
  menuItems: MenuUserConfigModel[] = new Array<MenuUserConfigModel>();

  constructor(
    private _userService: UserControllerService,
    private _menuService: MenuService,
    private _cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.user = this._userService.getUserLogged();
  }

  ngAfterViewInit(): void {
    this._menuService.getMenuAtual().subscribe(res => {
      this.menuItems = [];
      this._cdr.detectChanges();
      let items = MENU_USER_DATA_CONSTANT;
      if (!this._userService.getUserLogged().associado) {
        items = items.filter(x => !x.onlyAssociated);
      }
      this.menuItems = Object.assign([], items);
    })
  }

  clickItem(id): void {
    if (id == 7) {
      this.logout();
    } else {
      this.close();
    }
  }

  close(): void {
    this.show = !this.show;
  }

  logout(): void {
    this.close();
    this._userService.logout();
  }

  closeMenu(element?): void {
    if (!element) {
      return
    } else if (element.target && element.target.id == 'menubutton') {
      this.close();
    } else {
      return
    }
  }
}
